export class QuoteAdvisories {
  advisoryValue: string[] = [];
  bomLineId: string;
  isTesscoTuned: boolean = false;
}


export class QuoteAdvisoriesResult {
  bomLineId: string;
  advisoryValue: string ;
  advisoryId: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/quote-advisories.ts